(() => {
  const pushEvent = (eventName, parameters = {}) => {
    if (typeof window.belloTrack === "function") {
      window.belloTrack(eventName, parameters);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...parameters });
  };

  const bindTrackedLinks = (root = document) => {
    root.querySelectorAll("[data-av3-event]").forEach((element) => {
      if (element.dataset.av3EventBound === "true") return;
      element.dataset.av3EventBound = "true";
      element.addEventListener("click", () => {
        const productNode = element.closest("[data-product-id]");
        pushEvent(element.dataset.av3Event, {
          destination: element.getAttribute("href") || "",
          product_id: productNode?.dataset.productId || "",
          product_handle: productNode?.dataset.productHandle || "",
          variant_id: productNode?.dataset.variantId || "",
        });
      });
    });
  };

  const bindRunways = (root = document) => {
    root.querySelectorAll("[data-av3-runway]").forEach((runway) => {
      if (runway.dataset.av3RunwayBound === "true") return;
      runway.dataset.av3RunwayBound = "true";

      const viewport = runway.querySelector(".av3-runway__viewport");
      const cards = [...runway.querySelectorAll("[data-av3-runway-card]")];
      const count = runway.querySelector("[data-av3-runway-count]");
      const progress = runway.querySelector("[data-av3-runway-progress]");
      const previousButton = runway.querySelector("[data-av3-runway-previous]");
      const nextButton = runway.querySelector("[data-av3-runway-next]");
      if (!viewport || !cards.length) return;

      let frame = 0;
      let currentIndex = 0;
      const sync = () => {
        frame = 0;
        const viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
        let closestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const distance = Math.abs(cardCenter - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            currentIndex = index;
          }
        });

        cards.forEach((card, index) => {
          card.classList.toggle("is-current", index === currentIndex);
        });

        const currentLabel = String(currentIndex + 1).padStart(2, "0");
        const totalLabel = String(cards.length).padStart(2, "0");
        if (count) count.textContent = `${currentLabel} / ${totalLabel}`;
        if (progress) {
          progress.style.setProperty("--av3-runway-progress", `${(currentIndex + 1) / cards.length}`);
        }
      };

      const scrollToCard = (index) => {
        const card = cards[index];
        if (!card) return;
        const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
        const left = Math.max(0, card.offsetLeft - (viewport.clientWidth - card.offsetWidth) / 2);
        viewport.scrollTo({ left, behavior });
      };

      viewport.addEventListener(
        "scroll",
        () => {
          if (frame) cancelAnimationFrame(frame);
          frame = requestAnimationFrame(sync);
        },
        { passive: true },
      );
      previousButton?.addEventListener("click", () => {
        scrollToCard((currentIndex - 1 + cards.length) % cards.length);
      });
      nextButton?.addEventListener("click", () => {
        scrollToCard((currentIndex + 1) % cards.length);
      });
      sync();
    });
  };

  const init = (root = document) => {
    bindTrackedLinks(root);
    bindRunways(root);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
